import { WidgetData } from '@playbooks/core/src/interfaces'

import { BaseNode } from '../../'

export class WidgetNode<T extends WidgetData> extends BaseNode<T> {}
